var ELoggerLevel = /*#__PURE__*/function (ELoggerLevel) {
  ELoggerLevel["Debug"] = "debug";
  ELoggerLevel["Info"] = "info";
  ELoggerLevel["Log"] = "log";
  ELoggerLevel["Warn"] = "warn";
  ELoggerLevel["Error"] = "error";
  return ELoggerLevel;
}(ELoggerLevel || {});
function sendLog(message, level, messageContext) {
  // Added to also show the log on dev tools
  // eslint-disable-next-line no-console
  console[level](message, messageContext);
  var formattedMessage = typeof message === 'string' ? message : JSON.stringify(message);
  var formattedMeta = messageContext ? JSON.stringify(messageContext) : '';
  var logMessage = "".concat(level, ": ").concat(formattedMessage, " ").concat(formattedMeta);
  if (window.DDLogs && level !== ELoggerLevel.Debug) {
    window.DDLogs.log(logMessage, {
      level: level
    });
  }
}
export default function createLogger() {
  var logger = {
    error: function error(message, messageContext) {
      return sendLog(message, ELoggerLevel.Error, messageContext);
    },
    log: function log(message, messageContext) {
      return sendLog(message, ELoggerLevel.Log, messageContext);
    },
    warn: function warn(message, messageContext) {
      return sendLog(message, ELoggerLevel.Warn, messageContext);
    },
    info: function info(message, messageContext) {
      return sendLog(message, ELoggerLevel.Info, messageContext);
    },
    debug: function debug(message, messageContext) {
      return sendLog(message, ELoggerLevel.Debug, messageContext);
    }
  };
  return logger;
}